import { isInteger } from 'lodash';
import { rem } from 'polished';
import styled from 'styled-components';

import { GridComponentProps } from './Grid.types';

export const defaultSpacing = 8;

export const StyledGridContainer = styled.div<GridComponentProps>`
  width: 100%;
  display: flex;
  margin: auto;
  max-height: ${({ maxHeight }) => maxHeight && rem(maxHeight)};

  ${({ justifyContent = 'flex-start', alignItems = 'flex-start' }) => `
  justify-content: ${justifyContent};
    align-items: ${alignItems};
  `}
  top: ${({ top }) => top && (isInteger(top) ? rem(top) : '')};
  right: ${({ right }) => right && (isInteger(right) ? rem(right) : '')};
  left: ${({ left }) => left && (isInteger(left) ? rem(left) : '')};
  bottom: ${({ bottom }) => bottom && (isInteger(bottom) ? rem(bottom) : '')};
  ${({
    wrap = 'wrap',
    spacing = defaultSpacing,
    direction = 'row',
    position = 'unset',
  }) => `
    flex-wrap: ${wrap};
    column-gap: ${rem(spacing)};
    flex-direction: ${direction};
    position: ${position};
  `}
  ${({ theme }) => `
    max-width: ${(7.315 / theme.gridsystem.cols) * 100}vw;
    @media screen and (min-width: ${theme.breakpoints.s}) {
      max-width:${(7.315 / theme.gridsystem.cols) * 100}vw;
    }
    @media screen and (min-width: ${theme.breakpoints.m}) {
      max-width:${(7.315 / theme.gridsystem.cols) * 100}vw;
    }
    @media screen and (min-width: ${theme.breakpoints.l}) {
      max-width:${(7 / theme.gridsystem.cols) * 100}vw;
    }
    @media screen and (min-width: ${theme.breakpoints.xl}) {
      max-width:${(6 / theme.gridsystem.cols) * 100}vw;
    }
    @media screen and (min-width: ${theme.breakpoints.xxl}) {
      max-width:${(6 / theme.gridsystem.cols) * 100}vw;
    }
  `}
`;

export const StyledGrid = styled.div<GridComponentProps>`
  display: flex;
  width: 100vw;
  ${({ direction }) => direction && `flex-direction: ${direction};`}
`;
